import styled from 'styled-components';

export const Container = styled.div`
  background: ${(props) => props.theme.colors['neutral-30']};
  padding: 4px 10px;
  border-radius: 6px;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 12px;
  margin-right: 6px;
`;
